/**
 * Route paths for the Product Costing module.
 *
 * Every navigation inside this module goes through these builders rather than a literal, so a path
 * change is made in one place.
 */

/**
 * Ids reach these builders straight from `useParams()` and from API responses, so both are
 * optionally undefined. The literals these builders replaced interpolated them unchecked, which
 * renders `undefined` into the path — that behaviour is preserved deliberately rather than guarded,
 * so the two versions still navigate identically when an id is missing.
 */
type RouteId = string | undefined;

/**
 * Costing list for a development order.
 * @param devOrderId development order the costings belong to.
 * @returns the list path for this module.
 */
export const costingListPath = (devOrderId: RouteId): string => `/development-order/${devOrderId}/product-costing`;

/**
 * Detail page for one saved costing.
 * @param devOrderId development order the costing belongs to.
 * @param costingId the costing document id.
 * @returns the detail path for this module.
 */
export const costingDetailPath = (devOrderId: RouteId, costingId: RouteId): string =>
  `/development-order/${devOrderId}/product-costing-detail/${costingId}`;

/**
 * Detail page in create mode.
 * @param devOrderId development order the new costing will belong to.
 * @returns the create path for this module.
 */
export const costingAddPath = (devOrderId: RouteId): string => `/development-order/${devOrderId}/product-costing-detail/add`;
